var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-checkbox",class:{
    'v-checkbox--dark': _vm.isDark,
    'v-checkbox--light': !_vm.isDark,
},on:{"click":function($event){return _vm.invert()}}},[_c('div',{staticClass:"v-checkbox-icon",class:{'v-checkbox-icon--selected': _vm.isChecked}})])}
var staticRenderFns = []

export { render, staticRenderFns }